import BaseCollection from "@/collections/BaseCollection";

export default class ModusServiceCollection extends BaseCollection {
  constructor() {
    super();
  }

  // Route configuration
  routes() {
    const model = new (this.model())();
    
    return {
      fetch: `${
        process.env.VUE_APP_MODUS_REPOSITORY_URL
      }/api/v1/${model.modelName()}`,
      fetchDirectory: `${
        process.env.VUE_APP_MODUS_REPOSITORY_URL
      }/api/v1/${model.modelName()}/directory/{directory}`
    };
  }
}
